import api from '../../../App/socket';
import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';
import { getErrorMessage } from '../../../../shared/helpers';

export const createBikeLeadUpgrades = (bikeLeadId, data) => api.send({
    // name and price
    api: 'db',
    model: 'Bike_lead',
    action: 'NestedCreate',
    options: {
        fullPath: 'upgrades',
        where: { _id: bikeLeadId },
        create: {
            name: data.name,
            price: data.price,
        },
    },
}).then((response) => response).catch((error) => error);

export const updateBikeLeadUpgrades = (bikeLeadId, upgradesId, data) => api.send({
    // name and price
    api: 'db',
    model: 'Bike_lead',
    action: 'NestedUpdate',
    options: {
        where: {
            _id: bikeLeadId,
        },
        fullPath: `upgrades.${upgradesId}`,
        update: data,
    },
}).then((response) => response).catch((error) => error);

export const deleteBikeLeadUpgrades = (bikeLeadId, upgradesId) => (
    // name and price
    api.send({
        api: 'db',
        model: 'Bike_lead',
        action: 'NestedDelete',
        options: {
            fullPath: `upgrades.${upgradesId}`,
            where: { _id: bikeLeadId },
        },
    }).then((response) => response).catch((error) => error)
);

export const getBikeUpgradesList = async () => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: PURCHASING_API.BIKE_LEAD_UPGRADES,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: `Get bike upgrades: ${getErrorMessage(e)}`,
        };
    }
};

export const addBikeLeadUpgrades = (
    bikeLeadId = '62fe524e57fccc79a474d68b',
    parentUpgradeId = '62f10e22a63a1be29fc4eadc',
    additionalMod,
) => api.send({
    api: 'db',
    model: 'Bike_lead',
    action: 'NestedCreate',
    options: {
        fullPath: 'upgrades',
        create: {
            ref_bike_lead_upgrades: parentUpgradeId,
            additional_mod: additionalMod,
        },
        where: {
            _id: bikeLeadId,
        },
    },
}).then((response) => response).catch((error) => error);

export const removeBikeLeadUpgrades = (
    bikeLeadId = '62fe524e57fccc79a474d68b',
    parentUpgradeId = '62f10e22a63a1be29fc4eadc',
) => api.send({
    api: 'db',
    model: 'Bike_lead',
    action: 'NestedDelete',
    options: {
        fullPath: `upgrades.${parentUpgradeId}`,
        where: {
            _id: bikeLeadId,
        },
    },
}).then((response) => response).catch((error) => error);



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/requests/bike_lead_upgrades_request.js